function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { replaceData, noop, timeUntilStale, getAbortController } from './utils.esm.js';
import { defaultLogger } from './logger.esm.js';
import { notifyManager } from './notifyManager.esm.js';
import { createRetryer, isCancelledError, canFetch } from './retryer.esm.js';
import { Removable } from './removable.esm.js'; // CLASS

var Query = /*#__PURE__*/function (_Removable) {
  _inherits(Query, _Removable);

  var _super = _createSuper(Query);

  function Query(config) {
    var _this;

    _classCallCheck(this, Query);

    _this = _super.call(this);
    _this.abortSignalConsumed = false;
    _this.defaultOptions = config.defaultOptions;

    _this.setOptions(config.options);

    _this.observers = [];
    _this.cache = config.cache;
    _this.logger = config.logger || defaultLogger;
    _this.queryKey = config.queryKey;
    _this.queryHash = config.queryHash;
    _this.initialState = config.state || getDefaultState(_this.options);
    _this.state = _this.initialState;

    _this.scheduleGc();

    return _this;
  }

  _createClass(Query, [{
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread(_objectSpread({}, this.defaultOptions), options);
      this.updateCacheTime(this.options.cacheTime);
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      if (!this.observers.length && this.state.fetchStatus === 'idle') {
        this.cache.remove(this);
      }
    }
  }, {
    key: "setData",
    value: function setData(newData, options) {
      var data = replaceData(this.state.data, newData, this.options); // Set data and mark it as cached

      this.dispatch({
        data: data,
        type: 'success',
        dataUpdatedAt: options == null ? void 0 : options.updatedAt,
        manual: options == null ? void 0 : options.manual
      });
      return data;
    }
  }, {
    key: "setState",
    value: function setState(state, setStateOptions) {
      this.dispatch({
        type: 'setState',
        state: state,
        setStateOptions: setStateOptions
      });
    }
  }, {
    key: "cancel",
    value: function cancel(options) {
      var _this$retryer;

      var promise = this.promise;
      (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
      return promise ? promise.then(noop).catch(noop) : Promise.resolve();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Query.prototype), "destroy", this).call(this);

      this.cancel({
        silent: true
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.destroy();
      this.setState(this.initialState);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.observers.some(function (observer) {
        return observer.options.enabled !== false;
      });
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.getObserversCount() > 0 && !this.isActive();
    }
  }, {
    key: "isStale",
    value: function isStale() {
      return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
        return observer.getCurrentResult().isStale;
      });
    }
  }, {
    key: "isStaleByTime",
    value: function isStaleByTime() {
      var staleTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this$retryer2;

      var observer = this.observers.find(function (x) {
        return x.shouldFetchOnWindowFocus();
      });

      if (observer) {
        observer.refetch({
          cancelRefetch: false
        });
      } // Continue fetch if currently paused


      (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this$retryer3;

      var observer = this.observers.find(function (x) {
        return x.shouldFetchOnReconnect();
      });

      if (observer) {
        observer.refetch({
          cancelRefetch: false
        });
      } // Continue fetch if currently paused


      (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      if (this.observers.indexOf(observer) === -1) {
        this.observers.push(observer); // Stop the query from being garbage collected

        this.clearGcTimeout();
        this.cache.notify({
          type: 'observerAdded',
          query: this,
          observer: observer
        });
      }
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      if (this.observers.indexOf(observer) !== -1) {
        this.observers = this.observers.filter(function (x) {
          return x !== observer;
        });

        if (!this.observers.length) {
          // If the transport layer does not support cancellation
          // we'll let the query continue so the result can be cached
          if (this.retryer) {
            if (this.abortSignalConsumed) {
              this.retryer.cancel({
                revert: true
              });
            } else {
              this.retryer.cancelRetry();
            }
          }

          this.scheduleGc();
        }

        this.cache.notify({
          type: 'observerRemoved',
          query: this,
          observer: observer
        });
      }
    }
  }, {
    key: "getObserversCount",
    value: function getObserversCount() {
      return this.observers.length;
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      if (!this.state.isInvalidated) {
        this.dispatch({
          type: 'invalidate'
        });
      }
    }
  }, {
    key: "fetch",
    value: function fetch(options, fetchOptions) {
      var _this2 = this;

      var _this$options$behavio, _context$fetchOptions;

      if (this.state.fetchStatus !== 'idle') {
        if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
          // Silently cancel current fetch if the user wants to cancel refetches
          this.cancel({
            silent: true
          });
        } else if (this.promise) {
          var _this$retryer4; // make sure that retries that were potentially cancelled due to unmounts can continue


          (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

          return this.promise;
        }
      } // Update config if passed, otherwise the config from the last execution is used


      if (options) {
        this.setOptions(options);
      } // Use the options from the first observer with a query function if no function is found.
      // This can happen when the query is hydrated or created with setQueryData.


      if (!this.options.queryFn) {
        var observer = this.observers.find(function (x) {
          return x.options.queryFn;
        });

        if (observer) {
          this.setOptions(observer.options);
        }
      }

      if (!Array.isArray(this.options.queryKey)) {
        if (process.env.NODE_ENV !== 'production') {
          this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
        }
      }

      var abortController = getAbortController(); // Create query function context

      var queryFnContext = {
        queryKey: this.queryKey,
        pageParam: undefined,
        meta: this.meta
      }; // Adds an enumerable signal property to the object that
      // which sets abortSignalConsumed to true when the signal
      // is read.

      var addSignalProperty = function addSignalProperty(object) {
        Object.defineProperty(object, 'signal', {
          enumerable: true,
          get: function get() {
            if (abortController) {
              _this2.abortSignalConsumed = true;
              return abortController.signal;
            }

            return undefined;
          }
        });
      };

      addSignalProperty(queryFnContext); // Create fetch function

      var fetchFn = function fetchFn() {
        if (!_this2.options.queryFn) {
          return Promise.reject('Missing queryFn');
        }

        _this2.abortSignalConsumed = false;
        return _this2.options.queryFn(queryFnContext);
      }; // Trigger behavior hook


      var context = {
        fetchOptions: fetchOptions,
        options: this.options,
        queryKey: this.queryKey,
        state: this.state,
        fetchFn: fetchFn
      };
      addSignalProperty(context);
      (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

      this.revertState = this.state; // Set to fetching state if not already in it

      if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
        var _context$fetchOptions2;

        this.dispatch({
          type: 'fetch',
          meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
        });
      }

      var onError = function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!isCancelledError(error)) {
          var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2; // Notify cache callback


          (_this$cache$config$on = (_this$cache$config = _this2.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, _this2);
          (_this$cache$config$on2 = (_this$cache$config2 = _this2.cache.config).onSettled) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, _this2.state.data, error, _this2);

          if (process.env.NODE_ENV !== 'production') {
            _this2.logger.error(error);
          }
        }

        if (!_this2.isFetchingOptimistic) {
          // Schedule query gc after fetching
          _this2.scheduleGc();
        }

        _this2.isFetchingOptimistic = false;
      }; // Try to fetch the data


      this.retryer = createRetryer({
        fn: context.fetchFn,
        abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
        onSuccess: function onSuccess(data) {
          var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;

          if (typeof data === 'undefined') {
            if (process.env.NODE_ENV !== 'production') {
              _this2.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + _this2.queryHash);
            }

            onError(new Error(_this2.queryHash + " data is undefined"));
            return;
          }

          _this2.setData(data); // Notify cache callback


          (_this$cache$config$on3 = (_this$cache$config3 = _this2.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on3.call(_this$cache$config3, data, _this2);
          (_this$cache$config$on4 = (_this$cache$config4 = _this2.cache.config).onSettled) == null ? void 0 : _this$cache$config$on4.call(_this$cache$config4, data, _this2.state.error, _this2);

          if (!_this2.isFetchingOptimistic) {
            // Schedule query gc after fetching
            _this2.scheduleGc();
          }

          _this2.isFetchingOptimistic = false;
        },
        onError: onError,
        onFail: function onFail(failureCount, error) {
          _this2.dispatch({
            type: 'failed',
            failureCount: failureCount,
            error: error
          });
        },
        onPause: function onPause() {
          _this2.dispatch({
            type: 'pause'
          });
        },
        onContinue: function onContinue() {
          _this2.dispatch({
            type: 'continue'
          });
        },
        retry: context.options.retry,
        retryDelay: context.options.retryDelay,
        networkMode: context.options.networkMode
      });
      this.promise = this.retryer.promise;
      return this.promise;
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      var _this3 = this;

      var reducer = function reducer(state) {
        var _action$meta, _action$dataUpdatedAt;

        switch (action.type) {
          case 'failed':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchFailureCount: action.failureCount,
              fetchFailureReason: action.error
            });

          case 'pause':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchStatus: 'paused'
            });

          case 'continue':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchStatus: 'fetching'
            });

          case 'fetch':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchFailureCount: 0,
              fetchFailureReason: null,
              fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
              fetchStatus: canFetch(_this3.options.networkMode) ? 'fetching' : 'paused'
            }, !state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            });

          case 'success':
            return _objectSpread(_objectSpread({}, state), {}, {
              data: action.data,
              dataUpdateCount: state.dataUpdateCount + 1,
              dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
              error: null,
              isInvalidated: false,
              status: 'success'
            }, !action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            });

          case 'error':
            var error = action.error;

            if (isCancelledError(error) && error.revert && _this3.revertState) {
              return _objectSpread({}, _this3.revertState);
            }

            return _objectSpread(_objectSpread({}, state), {}, {
              error: error,
              errorUpdateCount: state.errorUpdateCount + 1,
              errorUpdatedAt: Date.now(),
              fetchFailureCount: state.fetchFailureCount + 1,
              fetchFailureReason: error,
              fetchStatus: 'idle',
              status: 'error'
            });

          case 'invalidate':
            return _objectSpread(_objectSpread({}, state), {}, {
              isInvalidated: true
            });

          case 'setState':
            return _objectSpread(_objectSpread({}, state), action.state);
        }
      };

      this.state = reducer(this.state);
      notifyManager.batch(function () {
        _this3.observers.forEach(function (observer) {
          observer.onQueryUpdate(action);
        });

        _this3.cache.notify({
          query: _this3,
          type: 'updated',
          action: action
        });
      });
    }
  }]);

  return Query;
}(Removable);

function getDefaultState(options) {
  var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  var hasData = typeof data !== 'undefined';
  var initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data: data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}

export { Query };